import { useAppStore } from '@store'
import { useMemo } from 'react'

export function useSceneObjects() {
  const currentLayer = useAppStore.use.currentLayer()
  const itemValues = useAppStore.use.items()
  const layers = useAppStore.use.layers()
  const contadorModificaciones = useAppStore((s) => s.contadorModificaciones)
  const sceneHistoryRevision = useAppStore((s) => s.sceneHistoryRevision ?? 0)
  const itemsID = layers[currentLayer]?.items
  const layerItemsKey = itemsID ? `${itemsID.size}:${Array.from(itemsID).join('|')}` : '0'

  return useMemo(
    () => Array.from(itemsID ?? []).map((el) => itemValues.get(el)),
    [itemsID, itemValues, contadorModificaciones, sceneHistoryRevision, layerItemsKey],
  )
}
